import TableCellTextDescriptor from './TableCell/TableCellText';
import TableCellCheckboxDescriptor from './TableCell/TableCellCheckbox';
import TableCellSelectDescriptor from './TableCell/TableCellSelect';
import TableCellSwitchDescriptor from './TableCell/TableCellSwitch';
import TableCellNumberDescriptor from './TableCell/TableCellMultiplier';

const Descriptors = [
  TableCellTextDescriptor,
  TableCellCheckboxDescriptor,
  TableCellSelectDescriptor,
  TableCellSwitchDescriptor,
  TableCellNumberDescriptor,
];

export const DescriptorsMap = Descriptors.reduce((acc, descriptor) => {
  acc[descriptor.name] = descriptor;
  return acc;
}, {} as Record<string, (typeof Descriptors)[number]>);
